import CrudTab from 'react/containers/pages/CrudTab';

class Reports extends CrudTab {
  static tabName = 'Monet.Reports.Tab.Title';

  componentDidMount() {
    const { tab: { pathname } } = this.props;
    const [routePrefix, userInterface, userInterfaceAction] = pathname.split('/').slice(1);
    this.router = new App.Routers[routePrefix]();
    this.router.makeForm(userInterface, userInterfaceAction);
  }

  componentDidUpdate(prevProps) {
    const { active, tab: { pathname } } = this.props;
    const [userInterface, userInterfaceAction] = pathname.split('/').slice(2);
    const isCommingFromAnotherTab = active !== prevProps.active;
    const didChangeTab = pathname !== prevProps.tab.pathname;

    if (!isCommingFromAnotherTab && active && didChangeTab) {
      this.router.makeForm(userInterface, userInterfaceAction);
    }
  }
}

export default Reports;
